import facebook from 'assets/images/icons/facebook.svg';
import discord from 'assets/images/icons/discord.svg';
import insta from 'assets/images/icons/insta.svg';
import youtube from 'assets/images/icons/youtube.svg';
import tiktok from 'assets/images/icons/tiktok.svg';
import telegram from 'assets/images/icons/telegram.svg';
import twitter from 'assets/images/icons/twitter.svg';
import email from 'assets/images/icons/sms.png';

// FaceBook: https://www.facebook.com/metastoken2025

// Discord: https://discord.gg/bP9pPRSSfY

// Instagram: https://www.instagram.com/metastoken2025/

// Youtube: https://www.youtube.com/@metastoken2025

// Tiktok: www.tiktok.com/@metamcc2025

// Email: metastoken2025@gmail.com

// Twitter: https://x.com/TokenMetas2025

const data = [
  {
    icon: facebook,
    url: 'https://www.facebook.com/metastoken2025',
  },
  {
    icon: discord,
    url: 'https://discord.gg/bP9pPRSSfY',
  },
  {
    icon: insta,
    url: 'https://www.instagram.com/metastoken2025/',
  },
  {
    icon: youtube,
    url: 'https://www.youtube.com/@metastoken2025',
  },
  {
    icon: tiktok,
    url: 'https://www.tiktok.com/@metastoken2025',
  },
  {
    icon: telegram,
    url: 'https://t.me/metasglobal',
  },
  {
    icon: twitter,
    url: 'https://x.com/TokenMetas2025',
  },
  {
    icon: email,
    url: 'mailto:metastoken2025@gmail.com',
  },
];

export default data;
